__turbopack_context__.v({
  "NoProviders": "q-WEiW_NoProviders",
  "Paragraph": "q-WEiW_Paragraph",
});
